(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-page-redirect"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const currentPage = window.location.pathname
    const cartPage = `${Shopify.routes.root}cart`

    if (currentPage === cartPage) {
      window.location.href = `${Shopify.routes.root}?modals=cart-drawer-dialog`
    }
  })

  } catch(e) { console.error(e); }
})();
})();
